/**
 * The happiness panel's skeleton, the mute pill inside it, and the bliss
 * toast -- the DOM half of what packages/client/src/happyhud.js drives (plus the purr's
 * one control: boot hands #mute to purr.bindMute).  The place rows are NOT
 * here: happyhud.js builds them from shared/happy.js's PLACES, so the page
 * can never list a place it could get wrong.  The markup is exactly the
 * static skeleton the old index.html carried, comments and all.
 */
import "./happy.css";
import { mount } from "./dom.js";

export function mountHappy(leftStack) {
  const happy = mount(`
  <!-- The happiness panel skeleton.  The place rows are built by
       happyhud.js from shared/happy.js's PLACES (this comment once said
       "eleven" and drifted twice before anyone noticed -- the row count
       lives in one file now, and it is not this one), so this page never
       lists a place it could get wrong. -->
  <div id="happy" class="panel">
    <div class="happy-head">
      <span class="label">Happiness</span>
      <span id="happy-word" class="label">purring</span>
      <button id="mute" type="button" aria-pressed="false"
              aria-label="Mute the purr">purr on</button>
    </div>
    <div id="happy-meter" aria-hidden="true"><i></i></div>
    <div class="hp-cap">purrs past the notch</div>
    <div id="happy-roster" class="label"></div>
    <!-- The hunt collection: filled by happyhud.js from the needs message's
         tally, hidden while empty.  The counts live on the server's record,
         so this line can never disagree with the cat's own history. -->
    <div id="happy-tally"></div>
    <!-- The treasure collection: filled by happyhud.js from the finds
         message, hidden while empty.  Same server-held-record bargain as
         the tally line above. -->
    <div id="happy-finds"></div>
    <div id="happy-next"></div>
    <div id="happy-list"></div>
  </div>`, leftStack);
  return { happy, mute: happy.querySelector("#mute") };
}

/** Fixed top-centre, a sibling of every panel: the moment belongs to the
    whole street, not to the happiness panel's corner.  Mounted late in
    ui/index.js's order, where the old page kept it. */
export function mountBliss() {
  return mount(`
<!-- Somebody banked a happy place; happyhud.js fills and times it.
     aria-live so a reader announces the moment without stealing focus. -->
<div id="bliss" class="panel" aria-live="polite"><b></b><span></span></div>`);
}
